import {useState} from "react";

export const useFetching = (callback) => {
    const [isLoading, setIsloading] = useState(false);
    const [error, setError] = useState('');
    const fetching = async (...args) => {
  try {
    setError(null);
    setIsloading(true);
    console.log(`Fetching started ${args}`);
    await callback(...args);
    console.log("Fetching success");
  } catch (e) {
    console.log("Fetching error:", e);
    setError(e.message);
  } finally {
    setIsloading(false);
  }
};
    return [fetching, isLoading, error];
}